import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Loading from '../../components/Loading';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import { TIPO_USUARIO } from '../../utils/funcoes';
import getResponseErrors from '../../utils/getResponseErrors';
import CadastroGrupoExames, { IGrupo } from './Cadastro';
import Listagem, { IPaginacao } from './Listagem/Index';

// import { Container } from './styles';
export interface IGrupos extends IGrupo {
  ativoFormatado: string;
  selecionadoFormatado: string;
}

const GrupoExames: React.FC = () => {
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.SUPERVISOR) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const { addToast } = useToast();
  const [grupos, setGrupos] = useState<IGrupos[] | undefined>(undefined);
  const [paginacao, setPaginacao] = useState<IPaginacao | undefined>(undefined);
  const [codigo, setCodigo] = useState<number | undefined>(undefined);
  const [novo, setNovo] = useState(false);

  const [loading, setLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState<number | undefined>(
    undefined,
  );

  useEffect(() => {
    setPaginacao({
      termoBusca: { nome: '', situacao: '' },
      pagina: 1,
      limite: 20,
    });
  }, []);

  const handleDelete = useCallback(
    async (gexCodigo: number) => {
      try {
        setLoading(true);
        await api.delete(`/grupoexames/deletegrupo/${gexCodigo}`);

        setGrupos(state => {
          return state && state.filter(st => st.GexCodigo !== gexCodigo);
        });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível excluir grupo',
          type: 'error',
          description: mensagemErro,
          timeAlive: 10000,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  useEffect(() => {
    async function buscaGrupos(): Promise<void> {
      if (paginacao) {
        try {
          setLoading(true);
          const { nome, situacao } = paginacao.termoBusca;
          let query = '';
          if (nome !== '') query = `&GexNome=${nome}`;
          if (situacao !== '') query = `${query}&GexAtivo=${situacao}`;

          const response = await api.get(
            `/grupoexames?pagina=${paginacao.pagina}&limite=${paginacao.limite}${query}`,
          );

          const gruposApi: IGrupos[] = response.data[0];

          const gruposFormatado = gruposApi.map(grp => {
            return {
              ...grp,
              ativoFormatado: grp.GexAtivo ? 'Sim' : 'Não',
              selecionadoFormatado: grp.GexSelecionado ? 'Sim' : 'Não',
            };
          });

          setTotalRegistros(
            response.data[1] === 0 ? undefined : response.data[1],
          );

          setGrupos(gruposFormatado);
        } catch (error) {
          const mensagemErro = getResponseErrors(error);
          addToast({
            title: 'Não foi possível buscar grupos',
            type: 'error',
            description: mensagemErro,
          });
        } finally {
          setLoading(false);
        }
      }
    }
    if (paginacao) buscaGrupos();
  }, [paginacao, addToast]);

  const handleProximaPagina = useCallback(
    (page: number) => {
      setPaginacao((state: IPaginacao | undefined) => {
        return state && { ...state, pagina: page };
      });
    },
    [setPaginacao],
  );

  return (
    <>
      {loading && <Loading />}
      {(codigo || novo) && (
        <>
          <CadastroGrupoExames
            grupo={grupos?.find(grp => grp.GexCodigo === codigo)}
          />
        </>
      )}
      {!codigo && !novo && (
        <Listagem
          grupos={grupos}
          setGrupos={setGrupos}
          paginacao={paginacao}
          setPaginacao={setPaginacao}
          totalRegistros={totalRegistros}
          handleDelete={handleDelete}
          handleProximaPagina={handleProximaPagina}
          setCodigo={setCodigo}
          setNovo={setNovo}
        />
      )}
    </>
  );
};

export default GrupoExames;
